<template>
  <div class="wrapper">
    <public-title month="期刊" @gotobtn="btn" @gotoinquire="eventinquire" :isbtn="true" btnname="新增"
      icon="el-icon-plus" @change= "change" :Vmonth.sync="Vmonth">
      
    </public-title>
    <div class="content">
      <el-table :data="tabledata" style="width: 100%" >
        <el-table-column prop="year" label="年份" width="120" align="center">
        </el-table-column>
        <el-table-column prop="month" label="月份" align="center">
        </el-table-column>
        <el-table-column prop="imgPath" label="封面" width="180" align="center">
          <template slot-scope="scope">
            <img style="width:100px;height:100px;object-fit: contain;" :src="URL + scope.row.imgPath" alt="">
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="上传时间" align="center">
        </el-table-column>
        <el-table-column label="操作" width="350" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" style="background: #014196;border-color: #014196;" @click="examine(scope.$index, scope.row)">查看</el-button>
            <el-button size="mini" type="primary" style="background: #0079A6;border-color: #0079A6;" @click="Uploadagain(scope.$index, scope.row)">重新上传</el-button>
            <el-button size="mini" type="primary" @click="edit(scope.$index, scope.row)">修改</el-button>
            <!-- <el-popconfirm icon="el-icon-info" v-model="DelVisible" confirmButtonText='确定' cancelButtonText='取消'
              @onConfirm="handleDelete(scope.$index, scope.row)" iconColor="red" style="margin-left: 10px;"
             :title="scope.row.articleNum>0?'该栏目已有关联文章，是否确认删除？':'您确定要删除这一条记录吗？'"> -->
              <el-button slot="reference" size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
            <!-- </el-popconfirm> -->
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
        :page-sizes="[15, 30, 40, 50]" :page-size="100" layout="total, sizes, prev, pager, next, jumper"
        :total="totals">
      </el-pagination>
    </div>
    
    <el-dialog :title="title" :visible.sync="dialogVisible" width="50%" :before-close="handleClose">
      <el-form ref="form" :model="subform" :rules="rules" label-width="80px">
        <el-form-item  label="年份月份" prop="date">
            <el-date-picker
            :disabled="isUploadagain?true:false"
            v-model="subform.date"
            style="width: 100%;"
            value-format="yyyy-MM"
            type="month"
            placeholder="选择月">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="上传PDF" prop="pdfurl">
          <upload ref="child2" divClass="upload-demo" @remve="remves()" v-model="subform.pdfurl" :pdfurls="subform.pdfurl" :pdfnames="subform.fileName" @Upload="uploadPDF"></upload>
        </el-form-item>
        <el-form-item  label="上传封面" prop="imgurl">
          <upload ref="child" divClass="avatar-uploader"  v-model="subform.imgurl" :imgurls="subform.imgurl"    @Success="uploadImg"></upload>
        </el-form-item>
        <el-form-item style="text-align: center;">
          <el-button type="primary" @click="onSubmit('form')">保存</el-button>
          <el-button @click="cancel()">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
  import publicTitle from '../../../components/publicTitle'
  import upload from '../../../components/upload.vue'

  export default {
    components: { publicTitle, upload },
    props: {},
    data(){
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error("请选择封面"));
        } else {
          callback();
        }
      };
      return {
        currentPage: 1,
        pageSize: 15,
        pageIndex: 1,
        totals: 0,
        form: {},
        subform:{
          date:'',
          pdfurl:'',
          imgurl:'',
          id:'',
          fileName:''
        },
        DelVisible: false,
        dialogVisible: false,
        rules: {
          date: [
            { required: true, message: '请选择时间', trigger: 'blur' },
          ],
          pdfurl: [
            { required: true, message: '请选择文件', trigger: 'change' },
          ],
          imgurl: [
            { required: true, message: '请选择封面', trigger: 'change' },
          ],
        },
        issubbtn:0, //add 0 - edit 1 - Uploadagain 2
        URL:'' , //图片URL
        tabledata:[],
        fileName:'',
        isUploadagain:false, //重新上传判断
        title:'',
        backPageIndex:sessionStorage.getItem("backPageIndex"), //获取用户选择的页码
        Vmonth:['',''], //期刊绑定的月份
        newMonth:['',''], //重新设置的值
        isSearch:0, //用户有没有点击搜索
      }
    },
    computed: {
    },
    mounted() {
      // if(sessionStorage.getItem("backPageIndex")){
      //   console.log("页码",this.backPageIndex)
      //   this.pageIndex = this.backPageIndex; //选择的页码存在就替换
      // }
      this.updata()
      this.URL = this.$URL
    },
    methods: {
      remves(){
        console.log('我被删除了')
        this.subform.pdfurl = null
        this.subform.fileName = null
        this.fileName = null
      },
      examine(index,item){
        console.log("查看",this.pageIndex)
        console.log("this.Vmonth",this.Vmonth)
        var date = {
          // year:item.year,
          // month:item.month
        }
        // this.$router.push({name: '期刊管理-查看', params: {ID: item.id,date}});/?page=${this.pageIndex}/?Vmonth=${this.form.Vmonth}
        // 
        this.$router.push({path:`/FileMange/Periodicalcheck/${item.id}/${item.year}/${item.month}`,query:{page:this.currentPage,Vmonth:this.Vmonth,newMonth:this.newMonth}});
      },
      //重新上传
      Uploadagain(index,item){
        console.log(item,'重新上传')
        this.isUploadagain = true;
        this.dialogVisible = true
        this.subform.date = item.year + '-' + item.month
        this.subform.imgurl = item.imgPath
        this.subform.pdfurl = item.url
        this.subform.fileName = item.fileName
        this.fileName = item.fileName
        this.subform.id = item.id
        this.issubbtn = 2
        this.title = '重新上传期刊文件'
      },
      // pageIndex = this.pageIndex, pageSize = 15,Vmonth=['','']
      updata(pageIndex = this.pageIndex, pageSize = 15,Vmonth= this.newMonth) {
        console.log("数据请求",Vmonth)
        this.$http({
          url: this.$api.periodicallist + `?pageIndex=${pageIndex}&pageSize=${pageSize}&startTime=${Vmonth[0]}&endTime=${Vmonth[1]}`,
          method: "GET",
        }).then(res => {
          if (res.data.code == 200) {
            // console.log(res.data, "返回");
            this.tabledata = res.data.data.records
            this.pageSize = res.data.data.size
            this.currentPage = res.data.data.current //当前选择的页面
            this.totals = res.data.data.total
          }else{
            this.$toast("error", res.data.msg);
          }
        });
      },
      //监听期刊月份变化
      change(val){
        this.Vmonth = val;
        // this.isSearch = 0;
        // this.form.Vmonth = val;
        console.log("监听this.Vmonth",this.Vmonth)
        console.log("需要传给查看的时间",this.newMonth)
        // console.log("this.form.Vmonth",this.form.Vmonth)
      },
      //查询 qyl2020/4/7 增加判断
      eventinquire() {
        // eventinquire(from) {
        // let Vmonth = this.form.Vmonth;

        let Vmonth = this.Vmonth;
        if(Vmonth.length == 0){
          this.Vmonth = ['','']
        }
        this.newMonth = Vmonth;
        this.updata(1, this.pageSize,this.newMonth)
      },
      
      handleSizeChange(val) {
        // console.log("vahandleSizeChangel",val)
        this.pageSize = val
        this.updata(this.pageIndex, this.pageSize,this.newMonth)
      },
      handleCurrentChange(val) {
        // console.log("handleCurrentChange",val)
        this.pageIndex = val;
        // sessionStorage.setItem("backPageIndex",this.pageIndex); //将用户选择的页码保存
        this.updata(this.pageIndex, this.pageSize,this.newMonth)
      },
      //修改按钮
      edit(index, item) {
        console.log(item,'修改')
        this.dialogVisible = true;
        this.issubbtn = 1
        this.subform.date = item.year + '-' + item.month
        this.subform.imgurl = item.imgPath
        this.subform.pdfurl = item.url
        this.subform.fileName = item.fileName
        this.subform.id = item.id
        this.title = '修改期刊'
        // console.log(this.subform)
      },
      //新增按钮
      btn(){
        this.dialogVisible = true
        this.issubbtn = 0
        this.subform.fileName = null
        this.title = '新增期刊'
      },
      //删除 update:qyl 2020/3/7 增加删除提示
      handleDelete(index, item) {
        this.$confirm(item.articleNum>0?'该期刊已有关联文章，是否确认删除？':'您确定要删除这一条记录吗？', "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$http({
          url: this.$api.periodicaldel + `${item.id}`,
          method: "DELETE",
        }).then(res => {
          if (res.data.code == 200) {
            this.$toast("success", res.data.msg);
            this.updata(1, this.pageSize ,this.newMonth)
          }else{
            this.$toast("error", res.data.msg);
          }
          this.DelVisible = false
        });
      });
        
      },
      onSubmit(formName) {
        console.log(this.subform,'点击')
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let userId = JSON.parse(sessionStorage.getItem("userinfo")).id
            if(this.issubbtn==0){
              let data = {
                userId,
                url:this.subform.pdfurl,
                imgPath:this.subform.imgurl,
                year:this.subform.date.split('-')[0],
                month:this.subform.date.split('-')[1],
                fileName:this.fileName //原始文件名
              }
              this.$http({
                url: this.$api.periodicalsave,
                method: "POST",
                data
              }).then(res => {
                if (res.data.code == 200) {
                  this.$toast("success", res.data.msg);
                  this.updata(1, this.pageSize ,this.newMonth)
                  this.dialogVisible = false
                  this.handleClose()
                }else{
                  this.$toast("error", res.data.msg);
                }
              })
            } else if(this.issubbtn==1){
              let data = {
                userId,
                id:this.subform.id,
                url:this.subform.pdfurl,
                year:this.subform.date.split('-')[0],
                month:this.subform.date.split('-')[1],
                imgPath:this.subform.imgurl,
                fileName:this.fileName //原始文件名
              }
              this.$http({
                url: this.$api.periodicalupdate,
                method: "PUT",
                data
              }).then(res => {
                if (res.data.code == 200) {
                  this.$toast("success", res.data.msg);
                  this.updata(this.pageIndex, this.pageSize,this.newMonth)
                  this.dialogVisible = false
                  this.handleClose()
                }else{
                  this.$toast("error", res.data.msg);
                }
              })
            }else if(this.issubbtn==2){
              console.log('重新')
              let data = {
                userId,
                id:this.subform.id,
                url:this.subform.pdfurl,
                fileName:this.fileName, //原始文件名
                imgPath:this.subform.imgurl
              }
              console.log(data)
              this.$http({
                url: this.$api.periodicalreupload,
                method: "POST",
                data
              }).then(res => {
                if (res.data.code == 200) {
                  this.$toast("success", res.data.msg);
                  this.updata(this.pageIndex, this.pageSize,this.newMonth)
                  this.dialogVisible = false
                  this.handleClose()
                }else{
                  this.$toast("error", res.data.msg);
                }
              })
            }
          } else {
            return false;
          }
        })
      },
      //接受子组件数据
      uploadPDF(url){
        //文件地址
        this.subform.pdfurl = url.path
        //文件名字
        //单独申明了一个this.fileName 防止watch监听两次
        //修改用的subform里的
        this.fileName = url.fileName
      },
      //接受子组件数据
      uploadImg(url){
        //图片地址
        this.subform.imgurl = url.path
      },
      //点X关闭
      handleClose(done) {
        this.dialogVisible = false;
        this.$refs['form'].resetFields();
        this.$refs.child.eliminateUrl()
        this.$refs.child2.eliminatePdf()
        this.subform.date = ''
        this.subform.imgurl = ''
        this.subform.pdfurl = ''
        this.subform.fileName = ''
        this.fileName = ''
        this.isUploadagain = false
      },
      //点取消关闭
      cancel(){
        this.handleClose()
        this.dialogVisible = false
      }
    },
    created() { 
      if(this.$route.params.pageIndex){
      //从路由上获取参数
        this.pageIndex = Number.parseInt(this.$route.params.pageIndex);
      }
      if(this.$route.params.Vmonth){
        this.Vmonth = this.$route.params.Vmonth; //改变子组件视图的值
      }
      if(this.$route.params.newMonth){
        this.newMonth = this.$route.params.newMonth; //改变搜索的值
      }
 
    },
    beforeDestroy() { }
  };
</script>

<style lang="scss" scoped>
  .role-select {
    width: 290px !important;
  }
  .content {
    background: #fff;
    width: 100%;
    height:100%;
    // overflow: auto;
  }
  /deep/.el-pagination {
    text-align: center;
    white-space: nowrap;
    padding: 10px 0;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
  }
    .wrapper{
    height: 100%;
  }
  /deep/.el-table{
  // overflow-x: scroll;
  height: 100%;
}
/deep/.el-table::before{
  background-color: none;
  opacity:0;
}
/deep/.el-table__body-wrapper{
  height:62vh;
    // margin-bottom: 7%;
    // padding-bottom: 5%;
    overflow-y: auto;
}
/deep/.el-table th>.cell{
  color: #000;
}
</style>